import React from 'react';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Cta from 'marketing-website/components/modules/Cta/CtaDefault';

const buttons = [
  {
    text: 'Get started for free',
    link: '/signup/',
    styles: {
      shape: 'rounded',
      size: 'large',
      minWidth: 160,
    },
  },
  {
    text: 'View plans',
    link: '/pricing/',
    styles: {
      shape: 'rounded',
      size: 'large',
      kind: 'ghost',
      minWidth: 160,
    },
  },
];

export default function CtaBlock() {
  return (
    <Spacing type="padding" size="m" position="topBottom">
      <Cta
        maxWidth={480}
        title="Join thousands of developers working smarter with Handoff. Get started for free."
        buttons={buttons}
      />
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/features/handoff/CtaBlock.js